
import { useAuth } from '@/contexts/auth';

/**
 * Simple hook that extracts just the user and access token from the centralized auth context.
 * This maintains backward compatibility while using the centralized auth system
 */
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useUser = () => {
  const { user, loading, isLoading } = useAuth();
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function fetchAccessToken() {
      const { data } = await supabase.auth.getSession();
      setAccessToken(data.session?.access_token ?? undefined);
    }
    fetchAccessToken();
    // It's fine to run only on mount or when user changes
  }, [user?.id]);

  return { 
    user, 
    loading: loading || isLoading, // Support both loading properties for compatibility
    accessToken
  };
};
